import * as React from 'react';
import {useState} from 'react';
import {RouteComponentProps} from "react-router";
import {
    CardObject,
    ExplanationCardQueryResult,
    useCreateCardMutation,
    useExplanationCardQuery,
    useRecentExplanationsQuery,
    useTopicQuery,
    useUpdateCardMutation
} from "../../../../types.d";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {CardTypeId} from "../../../../utils/constants";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";
import {TopicModal} from "../../../partials/modals/TopicModal";
import {ExplanationModal} from "../../../partials/modals/ExplanationModal";
import {Link} from "react-router-dom";

class Validator {}

export const RecentExplanationItem = (props: { card: CardObject }) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    return <li className="row">
        <div className="col-8">{ props.card.postTitle }</div>
        <div className="col-4">
            <a href="" onClick={e => {
                e.preventDefault();

                setModalVisible(true);
            }}>Show content</a>
        </div>

        <ExplanationModal
            visible={modalVisible}
            toggle={() => setModalVisible(!modalVisible)}
            card={props.card} />
    </li>;
};

export const ExplanationEdit = (props: RouteComponentProps<{ id: string, topic: string }>) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    const topicId = Number(props.match.params.topic);
    const id = props.match.params.id !== 'create' ? Number(props.match.params.id) : null;
    let item: ExplanationCardQueryResult;

    const recent = useRecentExplanationsQuery({
        variables: { topic: topicId }
    });

    const topicResponse = useTopicQuery({
        variables: { id: topicId }
    });

    const [ createCard, { data: createdCard } ] = useCreateCardMutation();
    const [ updateCard, { data: updatedCard } ] = useUpdateCardMutation();

    if (id) {
        item = useExplanationCardQuery({
            variables: { id }
        });
    }

    if ((item && !item.data) || !topicResponse || !topicResponse.data || !recent || !recent.data) {
        return <div className={'index-wrapper'}>
            <div className={'index-page'}>
                <h2>Loading...</h2>
            </div>
        </div>;
    }

    const topic = topicResponse.data.topic;
    const initialData = id ? {
        postTitle: item.data.card.postTitle,
        course: topic.stage.course.id,
        stage: topic.stage.id,
        explanationRules: item.data.card.explanationRules,
    } : {
        postTitle: topic.title + `(Explanation card ${recent.data.recentExplanations.length + 1})`,
        topic: topicId,
        course: topic.stage.course.id,
        stage: topic.stage.id,
        cardType: CardTypeId.Explanation,
    };

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to={`/courses/${topic.stage.course.sourceLanguage.id}`}>Course ({ topic.stage.course.sourceLanguage.name } -> { topic.stage.course.translationLanguage.name })</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        { id ? item.data.card.postTitle : 'Create explanation card' }
                    </li>
                </ol>
            </nav>

            <div className="row">
                <div className="col-7">
                    <div className="mt-4 row">
                        <div className="col-4"><h4 className="card-title text-left">Explanation Card: </h4></div>
                        <div className="col-8"><h4 className="card-title text-left">{ initialData.postTitle }</h4></div>
                    </div>
                    <div className="mt-4 row">
                        <div className="col-4"><h4 className="card-title text-left">Topic Overview: </h4></div>
                        <div className="col-8"><h4 className="card-title text-left">
                            <a href="" onClick={e => {
                                e.preventDefault();
                                setModalVisible(true);
                            }}>{ topic.title }</a></h4>
                        </div>

                        <TopicModal card={{
                            topic
                        } as CardObject} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
                    </div>
                </div>
                <div className="col-5"><h6 className="card-title text-left"><strong>Recently created explanation
                    cards</strong></h6>
                    <ul className="recently-created-cards-list">
                        { recent.data.recentExplanations.filter(item => !id || item.id !== id).map(item => (
                            <RecentExplanationItem key={item.id} card={item as CardObject} />
                        )) }
                    </ul>
                </div>
            </div>

            <div className={'mt-5'} />

            <Form
                validator={Validator}
                defaultData={initialData}
                onSubmit={async (data, done) => {
                    if (id) {
                        await updateCard({
                            variables: { id, input: data }
                        });
                    } else {
                        await createCard({
                            variables: { input: data }
                        });
                    }

                    done();
                }}>

                <FormGroup label={'Rules of the grammatically concept'} required={true}>
                    <Field
                        name={'explanationRules'}
                        render={props => <TinyMCE
                            toolbar={'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | table | help'}
                            {...props} />} />
                </FormGroup>

                <div className={'col-12'}>
                    <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
                </div>
            </Form>
        </div>
    </div>
};
